//lembre-se de também importar o CSS de cada um dos loaders
//styles/components/loader/component_name.css

import('./spinners.css')

export default {
    sk_circle(){
        return '<div class="sk-circle">'+
            '<div class="sk-circle1 sk-child"></div>'+
            '<div class="sk-circle2 sk-child"></div>'+
            '<div class="sk-circle3 sk-child"></div>'+
            '<div class="sk-circle4 sk-child"></div>'+
            '<div class="sk-circle5 sk-child"></div>'+
            '<div class="sk-circle6 sk-child"></div>'+
            '<div class="sk-circle7 sk-child"></div>'+
            '<div class="sk-circle8 sk-child"></div>'+
            '<div class="sk-circle9 sk-child"></div>'+
            '<div class="sk-circle10 sk-child"></div>'+
            '<div class="sk-circle11 sk-child"></div>'+
            '<div class="sk-circle12 sk-child"></div>'+
        '</div>';
    },
    defaultSpinner(number, color, size){
        return `<div class="spinner-${number} ${size}" style='border-right-color:${color}'></div>`
    },
    halfCircleSpinner(){
        return '<div class="half-circle-spinner-container"><div class="half-circle-spinner">'+
            '<div class="circle circle-1"></div>'+
            '<div class="circle circle-2"></div>'+
        '</div></div>'
    }
}